import React from "react";
import { motion } from "framer-motion";

const categories = [
    "Koncerty",
    "Firemné akcie",
    "Dni obce",
    "Dni mesta",
    "Konferencie",
    "Svadby",
    "Kultúrne podujatia",
    "Súkromné oslavy",
    "Galavečery",
    "Product launches",
];

export default function TargetAudiences() {
    return (
        <section
            className="relative py-24 sm:py-32 bg-nova-black border-y border-white/5 overflow-hidden"
            data-testid="target-audiences-section"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-12 mb-14">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <div className="font-mono text-xs uppercase tracking-[0.25em] text-nova-cyan mb-4">
                        / 02 — Pre koho pracujeme
                    </div>
                    <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.05]">
                        Spoľahlivý partner pre každý typ podujatia
                    </h2>
                </motion.div>
            </div>

            {/* Marquee */}
            <div className="relative overflow-hidden py-8">
                <div className="flex gap-6 animate-[marquee_40s_linear_infinite] whitespace-nowrap">
                    {[...categories, ...categories, ...categories].map((c, i) => (
                        <div
                            key={i}
                            className="shrink-0 px-8 py-4 border border-white/8 rounded-sm bg-nova-surface/30 hover:border-white/20 transition-colors group"
                            data-testid={`audience-chip-${i}`}
                        >
                            <span className="font-heading text-xl sm:text-2xl font-bold text-zinc-400 group-hover:text-white transition-colors">
                                {c}
                            </span>
                            <span className="ml-4 text-nova-cyan/30 font-mono text-[10px]">
                                /
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-33.33%); }
                }
            `}</style>
        </section>
    );
}
